import { render, staticRenderFns } from "./MasaKategori.vue?vue&type=template&id=2f37dd6a&scoped=true&"
import script from "./MasaKategori.vue?vue&type=script&lang=js&"
export * from "./MasaKategori.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f37dd6a",
  null
  
)

export default component.exports